export const ApiBaseUrl = "https://doctors-api.khalidelewa.com";
export const ApiBaseUrl2 = "https://localhost:5001";
